import { Credentials, VeryPassworResetRequest, loginResponse } from "src/models/auth";
import { API_ROUTES } from "../data/routes";
import { HttpClient } from "./config";


export const login = async (credentials: Credentials): Promise<any> => {
    return await HttpClient.post<loginResponse>(`${API_ROUTES.LOGIN}`, credentials);
}

export const resetPassword = async (email: string): Promise<any> => {
  return await HttpClient.post<any>(`${API_ROUTES.RESET_PASSWORD}`, { email });
}


export const verifyReset = async (data: VeryPassworResetRequest): Promise<any> => {
  return await HttpClient.post<any>(`${API_ROUTES.VERIFY_RESET}`, data);
}


export const getUser = async (email: string): Promise<any> => {
  return await HttpClient.get<any>(`${API_ROUTES.GET_USER}/${email}`,);
}
